/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import PricingDataContent from "components/content/PricingDataContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";

/**
 * Medical services pricing and fee schedule management page.
 * 
 * Features:
 * - CPT code pricing configuration
 * - Service fee schedules by provider and facility
 * - Insurance contract pricing management
 * - Price list version control and effective dates
 * - Discount and adjustment rules
 * - Integration with billing encounters for accurate pricing
 * 
 * @returns Pricing management page component
 */
const PricingPage: React.FC = () => {
  return (
    <DefaultDashboardLayout>
      <PricingDataContent />
    </DefaultDashboardLayout>
  );
};

export default PricingPage;
